var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.className,attrs:{"fill":"none","height":_vm.height,"viewBox":"0 0 23 40","width":_vm.width,"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.5 0L0.5 24H7.5V40L22.5 16H13.7L22.5 0H13.3333H0.5Z","fill":_vm.fill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }